import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoAltriRegistriStep2Component} from './conservazione-carica-documento-altri-registri-step2';

// @ngInject
const stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.conservazione-carica-documento-altri-registri-step2', {
      url: '/conservazione-carica-documento-altri-registri-step2',
      ncyBreadcrumb: {
        label: 'Carica Altri Registri',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      views: {
        homeContent: {
          template: '<conservazione-carica-documento-altri-registri-step2 flex="100"></conservazione-carica-documento-altri-registri-step2>'
        }
      }
    });
}

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoAltriRegistriStep2Module: string = ng
  .module('conservazione-carica-documento-altri-registri-step2', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('conservazioneCaricaDocumentoAltriRegistriStep2', ConservazioneCaricaDocumentoAltriRegistriStep2Component)
  .config(stateConfig)
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-altri-registri-step2/conservazione-carica-documento-altri-registri-step2.module.ts